'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uuid from "uuid";

export class NavbarComponent {
  menu = [{
    title: 'Home',
    state: 'main'
  }];
  isCollapsed = true;

  constructor($http,$scope, dbFactory, db) {
    'ngInject';

    this.$http = $http;
    this.$scope = $scope;
    this.dbFactory = dbFactory;
    this.db = db;

  }

  $onInit(){
    this.loadCountyList();
  }

  submitFeedback() {
    console.log(this.$scope.feedback);
    this.spin = true;
    console.log(uuid.v1());
    this.$scope.feedback.recid = uuid.v1();
    this.$http.post('https://api.mtcanalytics.org/api/feedback', this.$scope.feedback)
        .then(response => {
            console.log(response);
            // this.$anchorScroll();
            this.feedbackSuccess = true;
            this.$scope.feedback = {};
            this.spin = false;
            $('#feedbackModal').modal('hide');

        })
        .catch(err => {
            console.log(err);
        })
}

loadCountyList() {
  console.log("running...");
  this.$http
    .get("https://data.bayareametro.gov/resource/v6h3-e68p.json?$select=basis_county&$group=basis_county&$order=basis_county")
    .then((response) => {
      console.log(response.data);
      this.$scope.countyList = response.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

loadJurisdictions(county) {

    this.$http
      .get(
        `https://data.bayareametro.gov/resource/v6h3-e68p.json?basis_county='${county}'`
      )
      .then((response) => {
        this.$scope.jurisdictionList = response.data;
        console.log(this.$scope.jurisdictionList);
        this.$scope.selectedJurisdiction = "";
      })
      .catch((err) => {
        console.log(err);
      });
 
}


}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js